import styled, { css } from 'styled-components';
import { nuDSColor } from '@nubank/nuds-web/styles/themeUtils';
import Link from '@nubank/nuds-web/components/Link/Link';

import { themeSpace } from 'styles/themeUtils';

function panelBorderRadius(props) {
  const { rounded } = props;

  return (
    rounded
    && css`
      border-radius: 4px;
    `
  );
}

function panelBoxShadow(props) {
  const { shadow } = props;

  return (
    shadow
    && css`
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
    `
  );
}

export const Panel = styled.div`
  width: 100%;
  background-color: ${nuDSColor('white')};
  padding: ${themeSpace(2)};

  ${panelBorderRadius};
  ${panelBoxShadow};
`;

export const PanelHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const PanelBody = styled.div`
  padding-top: ${props => (props.open ? props.theme.spacing.unit * 2 : 0)}px;
  display: ${props => (props.open ? 'block' : 'none')};

  a {
    color: ${nuDSColor('primary')};
    font-size: ${props => props.theme.fontSizes[2]}px;
    margin-bottom: ${props => props.theme.spacing.unit * props.gutterBottom}px;
    outline: none;
    padding-bottom: 8px;
    cursor: pointer;
    line-height: 1.5;
    text-decoration: none;
  }
`;

export const IconWrapper = styled.i`
  display: flex;
  padding-left: ${themeSpace(1)};
`;

export const PanelLink = styled(Link)`
  flex-grow: 1;
  &:hover {
    text-decoration: none;
  }

  &:focus {
    outline: none;
  }
`;
